// ─── Today Page Data ──────────────────────────────────────────────────────────
// All module-level constants and pure helper functions extracted from
// TodayPage.tsx for maintainability.

export const _ATTRIBUTE_ORDER = [
  'Drive', 'Stability', 'Communication', 'Depth', 'Inspiration',
  'Authority', 'Discipline', 'Freedom', 'Rebirth', 'Vision',
];

export const _COSMIC_WEATHER: Record<string, string> = {
  'Drive': 'a day for bold beginnings',
  'Stability': 'ground yourself in what matters',
  'Communication': 'your words carry extra weight today',
  'Depth': 'listen to what stirs beneath the surface',
  'Inspiration': 'creative energy flows freely',
  'Authority': 'step into your leadership',
  'Discipline': 'sacred structure creates sacred freedom',
  'Freedom': 'follow the call of your untamed spirit',
  'Rebirth': 'something old must end for the new to begin',
  'Vision': 'trust what you see that others can\'t yet',
};

export const REFLECTION_PROMPTS: Record<string, string> = {
  'Drive': 'What would you pursue today if fear weren\'t a factor?',
  'Stability': 'What in your life deserves more of your steady attention?',
  'Communication': 'What truth have you been holding back?',
  'Depth': 'What emotion are you avoiding  -  and what does it want to teach you?',
  'Inspiration': 'What creative impulse have you been ignoring?',
  'Authority': 'Where in your life do you need to take the lead?',
  'Discipline': 'What daily ritual would transform your next 30 days?',
  'Freedom': 'What self-imposed rule is it time to break?',
  'Rebirth': 'What are you ready to let go of?',
  'Vision': 'What future are you building with today\'s choices?',
};

export const FALLBACK_REFLECTIONS = [
  'What is your soul trying to tell you today?',
  'Where are you holding tension that wants to be released?',
  'What would it look like to fully trust yourself right now?',
  'What are you becoming  -  and does it excite you?',
  'If today were a chapter title, what would it be?',
];

export const ATTR_MESSAGES: Record<string, string> = {
  'Drive': 'Your fire burns steady  -  let it guide, not consume.',
  'Stability': 'Rooted deep, you weather any storm.',
  'Communication': 'Your words carry frequency. Speak with intention.',
  'Depth': 'You see what others miss. Trust that vision.',
  'Inspiration': 'Your light reaches further than you know.',
  'Authority': 'Lead quietly  -  your presence speaks volumes.',
  'Discipline': 'Sacred structure creates sacred freedom.',
  'Freedom': 'The wild in you is not chaos  -  it\'s wisdom.',
  'Rebirth': 'Every transformation proves your resilience.',
  'Vision': 'You glimpse futures others can\'t yet imagine.',
};

export function getGreeting(): string {
  const h = new Date().getHours();
  if (h < 5) return 'Still up';
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  if (h < 21) return 'Good evening';
  return 'Good night';
}

export function getDisplayName(): string {
  try {
    // Try display name first
    const name = localStorage.getItem('zeal_display_name');
    if (name) return name.split(' ')[0];
    // Try birth data (has fullName)
    const birthRaw = localStorage.getItem('zeal_birth_data');
    if (birthRaw) {
      const birth = JSON.parse(birthRaw);
      if (birth.fullName) return birth.fullName.split(' ')[0];
    }
    // Try profile
    const profileRaw = localStorage.getItem('zeal_profile');
    if (profileRaw) {
      const profile = JSON.parse(profileRaw);
      if (profile.name) return profile.name.split(' ')[0];
    }
  } catch {}
  return 'Seeker';
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getCpsTierName(cps: number): string {
  if (cps >= 100) return 'Ascended';
  if (cps >= 85) return 'Sage';
  if (cps >= 70) return 'Oracle';
  if (cps >= 52) return 'Mystic';
  if (cps >= 34) return 'Adept';
  if (cps >= 16) return 'Initiate';
  return 'Seeker';
}

export function getAttrTier(score: number): { name: string; color: string } {
  if (score >= 11) return { name: 'Zeal', color: '#ff6b35' };
  if (score >= 9) return { name: 'Apex', color: '#c9a84c' };
  if (score >= 7.7) return { name: 'Flourishing', color: '#48c9b0' };
  if (score >= 6.3) return { name: 'Strength', color: '#5dade2' };
  if (score >= 5) return { name: 'Balanced', color: '#a8b2d1' };
  if (score >= 3.3) return { name: 'Awakening', color: '#e8d5a3' };
  return { name: 'Dormant', color: '#666' };
}
